<template>
  <div class="container-fluid h-100">
    <div class="content-conoce-el-club" id="content-club" title="Conoce el club" alt="Conoce el club">
      <div
        class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 ">
        <div class="col-12 col-md-8 col-lg-8 col-xl-8 col-sm-8">
          <h1 class="page_title">
            ¡CONOCE EL CLUB!
          </h1>
        </div>
        <div class="col-12 col-md-9 col-lg-9 col-xl-6 col-sm-6 mt-5">
          <div class="row justify-content-center">
            <div
              v-for="item in menu" :key="item.id"
              class="col-12 col-md-2 col-lg-2 col-xl-2 col-sm-2 card"
              @click="goTo(item.routeName)"
            >
              <p class="text-link">{{ item.text }}</p>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        route: null,
        menu: []
      };
    },
    methods: {
      showMenu(rout){
        this.menu = [
          {
            id: 1,
            routeName: rout == "GetToKnowTheClub" ? "club" : "club1",
            text: "¿Qué es el club?",
            count: true,
            subItem: []
          },
          {
            id: 2,
            routeName: rout == "GetToKnowTheClub" ? "registerCodes" : "registerCodesP",
            text: "¿Cómo registrar códigos?",
            count: true,
            subItem: []
          },
          {
            id: 3,
            routeName: rout == "GetToKnowTheClub" ? "contact" : "contact1",
            text: "Contáctanos",
            count: true,
            subItem: []
          },
          {
            id: 4,
            routeName: rout == "GetToKnowTheClub" ? "frequentQuestions" : "frequentQuestionsP",
            text: "Preguntas frecuentes",
            count: true,
            subItem: []
          }
        ]
      },
      goTo(route){
        this.$router.push({ name: route });
      }
    },
    mounted(){
      this.route = this.$route.name;
      this.showMenu(this.route);
    },
  }
</script>

<style scoped>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.content-conoce-el-club {
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
  background-size: cover;
  background-image: url("./../../assets/img/fondo_conoce_el_club.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.page_title {
  font-size: 50px;
  font-family: 'Gotham-UltraItalic', sans-serif;
}
.card{
  background: #1da5df;
  /* backdrop-filter: blur(3px); */
  margin: 15px;
  box-shadow: 0px 0px 15px black;
  justify-content: center;
  cursor: pointer;
}
.card:hover{
  transform: scale(1.2);
  transition-duration: 0.3s;
}
.card:hover > p{
  /* color: #dc3545; */
}
.text-link{
  padding-top: 10px;
  font-size: 15px;
  color: white;
  font-family: 'Gotham-UltraItalic', sans-serif;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .content-conoce-el-club {
    padding-top: 35%;
    padding-bottom: 12%;
    height: 100%;
  }
  .page_title {
    font-size: 40px;
  }
  .text-link{
    padding-bottom: 20px;
  }
}
</style>